import { Button, Col, Form, Input, InputNumber, Popconfirm, Row, Select, Switch, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import getList from '../../universal/getList';


const FaPiao = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data, closeModal } = props;
    const [loading, setLoading] = useState<boolean>(false)
    const [faPiaoInfo, setFaPiaoInfo] = useState<any>();
    const [maxTotalAmount, setMaxTotalAmount] = useState<number>(0);
    const [printData, setPrintData] = useState<Array<any>>([])

    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        setLoading(true)
        closeModal()
        form.validateFields() //数据校验
            .then(async (values: any) => {
                fetchApi.POST(wmService, {
                    apiId: "cateringOrder",
                    apiExtend: "faPiao",
                    apiData: {
                        id: data.orderId,
                        dataStatusType: data.dataStatusType,
                        branchStoreId: data.branchStoreId,
                        ...values


                    }
                }).then(res => {


                    antMessage('success', '开发票成功', 'success', { duration: 0.5 });

                    closeModal(true)

                }).catch(err => {
                    setLoading(false)
                    antMessage('error', '错误', err.message + ' | status：' + err.errors.status, { duration: 0.5 });

                })
            })
            .catch((err: any) => {
                antMessage('warning', '无法通过数据校验', '请输入所需数据', { duration: 0.5 });

                console.log("err", err);
                setLoading(false)

            });

    };
    const handleCancel = (e: any) => {
        closeModal()
    };

    /** 后端数据defaultService */
    let wmService: any = systemConfig.wmService;

    // const [branchStoreData, setBranchStoreData] = useState<any>();
    // const [roomData, setRoomData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        //同步获取数据 async - await
        const fetchData = async () => {
            fetchApi.GET(wmService,
                {
                    apiId: 'printer',
                    apiExtend: 'showList',
                    apiData: {
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },
                    }

                }).then(res => {

                    if (res.success) {
                        setPrintData(res.data)
                    }
                });
            // fetchApi.GET(defaultService,
            //     {
            //         apiId: 'branchStore',
            //         apiExtend: 'showList'
            //     }).then(res => {
            //         if (res.success) {
            //             setBranchStoreData(res.data);
            //         }
            //     });
            // fetchApi.GET(defaultService,
            //     {
            //         apiId: 'room',
            //         apiExtend: 'showList'
            //     }).then(res => {
            //         if (res.success) {
            //             setRoomData(res.data);
            //         }
            //     });
        };
        fetchData();
        initData()
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据
    const initData = async (id?: string) => {
        fetchApi.GET(wmService, {
            apiId: "cateringOrder",
            apiExtend: "orderToFaPiao",
            apiData: {
                id: data.orderId,
                dataStatusType: data.dataStatusType,
                branchStoreId: data.branchStoreId
            }

        }).then((res) => {
            if (res.success) {


                let maxTotalAmount = res.data.totalAmount;
                let printId = res.data.printId;
                let faPiaoId = res.data.faPiaoId;
                setMaxTotalAmount(maxTotalAmount)

                form.setFieldValue("totalAmount", res.data.totalAmount)
                if (faPiaoId) form.setFieldValue("faPiaoId", faPiaoId)



                if (printId) {
                    form.setFieldValue("printId", printId);
                }
                setFaPiaoInfo(res.data)

            }

        }).catch((err) => {
            console.log("errr", err);

        })
    }
    // let extendProps: WEUExtendPropsType = {
    //     ...props,
    //     form,
    //     apiId: 'cateringOrder',
    // };
    const faPiaoVoided = async () => {
        fetchApi.POST(wmService, {
            apiId: "cateringOrder",
            apiExtend: "faPiaoVoided",
            apiData: {
                id: data.orderId,
                faPiaoId: faPiaoInfo?.faPiaoId

            }

        }).then((res) => {
            if (res.success) {
                antMessage('success', '作废/冲红成功', 'success', { duration: 0.5 });
                closeModal()


            }

        }).catch((err) => {
            antMessage('error', '作废/冲红失败', JSON.stringify(err), { duration: 0.5 });
            console.log("errr", err);

        })


    }
    return (
        <>
            <AntDraggableModal
                title={<div>发票信息--{faPiaoInfo?.faPiaoId ? <><span>开发票二维码:{faPiaoInfo?.faPiaoQrCodeStatus.name}--开票状态：{faPiaoInfo?.faPiaoStatus.name}</span>-- <Popconfirm title="确定要作废吗？" onConfirm={() => faPiaoVoided()} okText="确定" cancelText="取消">
                    <Button type='text' size='small' danger>作废</Button>
                </Popconfirm></> : "未开发票二维码"}</div>}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                confirmLoading={loading}
                width={"50%"}

            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>
                    <Row>
                        {faPiaoInfo?.faPiaoId ? <Col span={12}>
                            <Form.Item
                                label="发票id"
                                name="faPiaoId">
                                <Input readOnly />
                            </Form.Item>
                        </Col> : null}
                        <Col span={12}>
                            <Form.Item
                                label="开票金额"
                                name="totalAmount">
                                <InputNumber max={maxTotalAmount} readOnly={faPiaoInfo?.faPiaoId ? true : false} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="指定打印机"
                                name="printId">
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="指定打印机"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(printData, 'printerName')}
                                </Select>
                            </Form.Item>

                        </Col>


                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default FaPiao;